import Main from './GovernanceProjectsMain'

const GovernanceProjects = {
  Main,
}

export default GovernanceProjects
